<template>
  <section>
    <article
      v-for="index in count"
      :key="index"
      class="list-item__card list-item__card--placeholder"
      data-placeholder
    >
      <div class="list-item__member"></div>
      <div class="list-item__message"></div>
      <div class="list-item__message"></div>
    </article>
  </section>
</template>
<script>
export default {
  props: {
    count: {
      type: Number,
      default: 5
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_non-rendering';
.list-item__card.list-item__card--placeholder {
  cursor: initial;
  position: relative;

  &::after {
    @extend %skeleton;
  }
}
</style>
